module.exports = __webpack_public_path__ + "static/img/15010C_1_2_R_20211207_LC.bb657ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15010C_1_2_R_20211207_LC.png
// module id = 2UCq
// module chunks = 0